import type { FC } from 'react'
import styled from '@emotion/styled'

import HeroRecipeBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import HeroImage from './HeroImage'

import ApplePodcastsBadge from './assets/ApplePodcastsBadge.svg'
import GooglePodcastsBadge from './assets/GooglePodcastsBadge.svg'
import SpotifyBadge from './assets/SpotifyBadge.svg'

const copy = {
  overline: `Original Content  `,
  heading: `Good Data, <br>Better Marketing`,
  description: `Your view into the minds of influential marketers, digital innovators and their tricks of the trade. Tune in to hear from enterprise experts as they share how to use data as a competitive asset to drive customer engagement.`,
}

export interface HeroProps {
  simplecastId?: string
  applePodcastsUrl?: string
  googlePodcastsUrl?: string
  spotifyUrl?: string
}

const Hero: FC<HeroProps> = ({ simplecastId, applePodcastsUrl, googlePodcastsUrl, spotifyUrl }) => (
  <Wrapper>
    <StyledHeroRecipeBase variant="2Col">
      <HeroRecipe.Copy>
        <CopyInner>
          <CopyTextBase>
            <CopyText.Overline variant="h5">{copy.overline}</CopyText.Overline>
            <CopyText.Heading variant="h1" tag="h1" dangerouslySetInnerHTML={{ __html: copy.heading }} />
            <CopyText.Description tag="p" variant="pLarge">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
          <PlayersWrapper>
            {simplecastId && (
              <iframe
                width="100%"
                frameBorder="no"
                scrolling="no"
                seamless={true}
                src={simplecastId}
                title="Play the featured episode"
              ></iframe>
            )}
            <BadgesWrapper>
              {applePodcastsUrl && (
                <Badge href={applePodcastsUrl} target="_blank" title="Listen on Apple Podcasts">
                  <ApplePodcastsBadge />
                </Badge>
              )}
              {googlePodcastsUrl && (
                <Badge href={googlePodcastsUrl} target="_blank" title="Listen on Google Podcasts">
                  <GooglePodcastsBadge />
                </Badge>
              )}
              {spotifyUrl && (
                <Badge href={spotifyUrl} target="_blank" title="Listen on Spotify">
                  <SpotifyBadge />
                </Badge>
              )}
            </BadgesWrapper>
          </PlayersWrapper>
        </CopyInner>
      </HeroRecipe.Copy>
      <HeroRecipe.Contents>
        <HeroImage />
      </HeroRecipe.Contents>
    </StyledHeroRecipeBase>
  </Wrapper>
)

export default Hero

const Wrapper = styled.header`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-top: 80px;
  }
`

const BadgesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(143px, 1fr));
  column-gap: 9px;
  row-gap: 5px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    gap: 17px;
    row-gap: 14px;
  }
`

const CopyInner = styled.div`
  display: grid;
  gap: 40px;
`

const PlayersWrapper = styled.div`
  display: grid;
  gap: 24px;
`

const StyledHeroRecipeBase = styled(HeroRecipeBase)`
  ${HeroRecipe.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 0;
    }
  }
`

const Badge = styled.a``
